export default __webpack_public_path__ + "static/media/Chevron-up-5254.3652e2fc.svg";